// PLUGINS IMPORTS //
import React from "react"
import styled from "styled-components/macro"

// COMPONENTS IMPORTS //
import SectionItem from "../Shared/SectionItem/SectionItem"
import FeatureItem from "./FeatureItem/FeatureItem"
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  title: string
  features: Array<string>
}

const Features: React.FC<PropsType> = (props) => {
  return (
    <SectionItem title={`Features of ${props.title}`}>
      <ul>
        {props.features.map((text) => (
          <FeatureItem text={text} />
        ))}
      </ul>
    </SectionItem>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div``

export default React.memo(Features, memoComparison)
